import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'TimeFormatPipe',
})
export class TimeFormatPipe implements PipeTransform {
  transform(time: string): string {
    if (!time) return '';
    const match = time.match(/^(\d{2}:\d{2}):\d{2}$/);
    return match ? match[1] : time;
  }
}
